module.exports = __webpack_public_path__ + "img/fibra-oscura.0b28ae9c.png";